// frontend/src/pages/RequestsPurchases.jsx
import { useTranslation } from 'react-i18next'
import Purchases from './Purchases'

export default function RequestsPurchases() {
  const { t } = useTranslation('purchases')
  return (
    <div>
      <div className="px-6 pt-4">
        <p className="text-xs text-gray-500">
          {t('requests.hint')}{' '}<span className="font-medium text-gray-700">{t('requests.acquisitions')}</span>.
        </p>
      </div>
      <Purchases hideDownload />
    </div>
  )
}
